import React from "react";
import loaderImage from "../../../assets/images/ajax-loader-large.gif";

const Spinner = ({ size }) => {
  return (
    <img src={loaderImage} width={size} height={size} />
  );
};

export default Spinner;
